import { Navigate, Outlet, useLocation } from "react-router";
import { Match } from "effect";

import { useAuth } from "#auth.tsx";
import type { StaffRole } from "../../../packages/common/src/schemas/auth.ts";

/** Prevents staff data from rendering before the refresh-cookie check succeeds. */
export function ProtectedRoute() {
  const { state } = useAuth();
  const location = useLocation();

  return Match.value(state).pipe(
    Match.when({ kind: "loading" }, () => (
      <main className="centered">Checking your session…</main>
    )),
    Match.when({ kind: "anonymous" }, () => (
      <Navigate
        to={`/login?${new URLSearchParams({ returnTo: location.pathname + location.search })}`}
        replace
      />
    )),
    Match.when({ kind: "authenticated" }, () => <Outlet />),
    Match.exhaustive,
  );
}

/** Keep administrator pages out of the kitchen role's render tree. */
export function RoleRoute({
  allow,
}: {
  readonly allow: readonly StaffRole[];
}) {
  const { state } = useAuth();

  return state.kind === "authenticated" && allow.includes(state.role) ? (
    <Outlet />
  ) : (
    <Navigate to="/admin/kitchen" replace />
  );
}
